import React, { Component  } from "react"
import Select from "../../../../components/Select"
import cfg from "../../../../utils/config"
import auth from "../../../../utils/auth"
import ButtonsForm from "../../../../components/ButtonsForm"
import axios from "axios"
import helper from "../../../../utils/helper"
import { Link, Redirect } from "react-router-dom"

class FormGroupMulticast extends Component {
    applicationId = this.props.match.params.id
    userInfo = auth.getUserInfo()

    state = { 
        detalhes: { name: null, mc_addr: null, mc_nwk_s_key: null, mc_app_s_key: null, region: null, dr: 0, f_cnt: 0, frequency: 0, group_type: {label: 'Classe-C', value: 'CLASS_C'}, class_b_ping_slot_nb_k: null, class_c_scheduling_type: null },
        cooldown: false,
        redirect: false,
        path: "",
        optionsSelect: { region: [], group_type: [], class_b_ping_slot_nb_k: [], class_c_scheduling_type: [] }
    }

    componentDidMount = async () => {
        await this.getOptionsSelect()
        
        if (this.props.match.params.idGroup) {
            this.getData()
        }
    }

    getOptionsSelect = async () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/selects/informations/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        return axios.get(requestURL, config_me).then((res) => {
            const data = res.data

            this.setState({
                optionsSelect: { 
                    region: data.region, 
                    group_type: data.group_type, 
                    class_b_ping_slot_nb_k: data.class_b_ping_slot_nb_k, 
                    class_c_scheduling_type: data.class_c_scheduling_type
                }
            })
        })
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/multicast/group/' + this.props.match.params.idGroup + '/' 
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            const optionsSelect = this.state.optionsSelect
        
            const detalhes = { 
                name: data.name, 
                mc_addr: data.mc_addr, 
                mc_nwk_s_key: data.mc_nwk_s_key, 
                mc_app_s_key: data.mc_app_s_key, 
                region: optionsSelect.region.filter((item) => item.value === data.region)[0], 
                dr: data.dr, 
                f_cnt: data.f_cnt, 
                frequency: data.frequency, 
                group_type: optionsSelect.group_type.filter((item) => item.value === data.group_type)[0], 
            }

            if(data.group_type === "CLASS_B") {
                detalhes["class_b_ping_slot_nb_k"] = optionsSelect.class_b_ping_slot_nb_k.filter((item) => item.value === data.class_b_ping_slot_nb_k)[0]
            } 

            if(data.group_type === "CLASS_C") {
                detalhes["class_c_scheduling_type"] = optionsSelect.class_c_scheduling_type.filter((item) => item.value === data.class_c_scheduling_type)[0]
            }

            this.setState({ detalhes })
        })
    }

    handleChange = (field, value, isNumber = false) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const span = document.getElementById(`validacao-${field}`)

        if(isNumber){
            value = value.replace(/[.,e]/g, "")
            value = value ? parseInt(value) : 0
        }

        detalhes[field] = value
        
        if(span) {
            span.innerHTML = ""
        }

        this.setState({ detalhes })
    }

    saveAction = (novoCadastro) => {
        const { detalhes } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""

        if (this.props.match.params.idGroup) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/multicast/group/' + this.props.match.params.idGroup + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/multicast/group/'
            verb = 'post'
        }

        const data = {}

        data["name"] = detalhes.name ?? ""
        data["mc_addr"] = detalhes.mc_addr ?? ""
        data["mc_nwk_s_key"] = detalhes.mc_nwk_s_key ?? ""
        data["mc_app_s_key"] = detalhes.mc_app_s_key ?? ""
        data["region"] = detalhes.region?.value ?? ""
        data["dr"] = detalhes.dr
        data["f_cnt"] = detalhes.f_cnt
        data["frequency"] = detalhes.frequency
        data["group_type"] = detalhes.group_type.value

        if(detalhes.group_type.value === "CLASS_B") {
            data["class_b_ping_slot_nb_k"] = detalhes.class_b_ping_slot_nb_k?.value ?? ""
        } 

        if(detalhes.group_type.value === "CLASS_C") {
            data["class_c_scheduling_type"] = detalhes.class_c_scheduling_type?.value ?? ""
        }


        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                helper.dispatchEvent("showAviso", {
                    message: `Grupo Multicast ${verb === "post" ? "criado" : "editado"} com sucesso.`,
                    callback: () => this.setState({ redirect: true, path: `/lns/application/${this.applicationId}/editar/2` }),
                    callbackClose: verb === "post" ?
                        () => {
                            window.location.href = `/lns/application/${this.applicationId}/multicast-group/${res.data.id}/editar`
                            setTimeout(() => { window.location.reload() }, 1000)
                        }
                    : null
                })
            }
        }).catch((error) => {
            if(typeof error.response.data === "string") {
                helper.dispatchEvent("showAviso", {
                    message: error.response.data
                })

                return
            }

            let erros = Object.entries(error.response.data)

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    let span = document.querySelector(`#validacao-${erros[i][0]}`)
                    if (span) span.innerHTML = erros[i][1]
                }
            }
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    render() {
        const { detalhes, optionsSelect } = this.state
        const edit = this.props.match.params.idGroup ? true : false

        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }
        
        return (
           <div>
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        {this.props.match.params.idGroup ? <h4>Editar Grupo Multicast</h4> : <h4>Novo Grupo Multicast</h4>}
                        <div className="gray-background">
                            <i className="las la-hdd la-2x"></i> 
                        </div>
                    </span>
                </div>

                <div className="hdv-form-default">
                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="name">Nome do grupo multicast</label>
                            <input
                                type='text'
                                value={detalhes.name ?? ""}
                                id="name"
                                onChange={(e) => this.handleChange("name", e.target.value)}
                            />
                            <span id='validacao-name'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="mc_addr">Endereço do multicast</label>
                            <input
                                type='text'
                                value={detalhes.mc_addr ?? ""}
                                id="mc_addr"
                                onChange={(e) => this.handleChange("mc_addr", e.target.value)}
                            />
                            <span id='validacao-mc_addr'></span>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="mc_nwk_s_key">Chave de sessão de rede multicast</label>
                            <input
                                type='text'
                                value={detalhes.mc_nwk_s_key ?? ""}
                                id="mc_nwk_s_key"
                                onChange={(e) => this.handleChange("mc_nwk_s_key", e.target.value)}
                            />
                            <span id='validacao-mc_nwk_s_key'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="mc_app_s_key">Chave de sessão do aplicativo multicast</label>
                            <input
                                type='text'
                                value={detalhes.mc_app_s_key ?? ""}
                                id="mc_app_s_key"
                                onChange={(e) => this.handleChange("mc_app_s_key", e.target.value)}
                            />
                            <span id='validacao-mc_app_s_key'></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <label className='required' htmlFor="region">Região</label>
                            <Select
                                options={optionsSelect.region}
                                value={detalhes.region}
                                onChange={(e) => {this.handleChange("region", e)}}
                                
                            />
                            <span id='validacao-region'></span>
                        </div>
                        <div className="col-md-3">
                            <label className='required' htmlFor="dr">Taxa de dados</label>
                            <input
                                type='text'
                                value={detalhes.dr ?? ""}
                                id="dr"
                                onChange={(e) => this.handleChange("dr", e.target.value, true)}
                            />
                            <span id='validacao-dr'></span>
                        </div>
                        <div className="col-md-3">
                            <label className='required' htmlFor="f_cnt">Contador de quadros</label>
                            <input
                                type='text'
                                value={detalhes.f_cnt ?? ""}
                                id="f_cnt"
                                onChange={(e) => this.handleChange("f_cnt", e.target.value, true)}
                            />
                            <span id='validacao-dev_eui'></span>
                        </div>
                        <div className="col-md-3">
                            <label className='required' htmlFor="frequency">Frequência (Hz)</label>
                            <input
                                type='text'
                                value={detalhes.frequency ?? ""}
                                id="frequency"
                                onChange={(e) => this.handleChange("frequency", e.target.value, true)}
                            />
                            <span id='validacao-frequency'></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <label className='required' htmlFor="group_type">Tipo de grupo</label>
                            <Select
                                options={optionsSelect.group_type}
                                value={detalhes.group_type}
                                onChange={(e) => this.handleChange("group_type", e)}
                            />
                            <span id='validacao-group_type'></span>
                        </div>
                        <div className="col-md-4">
                            <label className='required' htmlFor="class_b_ping_slot_nb_k">Periodicidade do slot de ping de classe B</label>
                            <Select
                                disabled={detalhes.group_type.value !== "CLASS_B"}
                                options={optionsSelect.class_b_ping_slot_nb_k}
                                value={detalhes.class_b_ping_slot_nb_k}
                                onChange={(e) => this.handleChange("class_b_ping_slot_nb_k", e)}
                            />
                            <span id='validacao-class_b_ping_slot_nb_k'></span>
                        </div>
                        <div className="col-md-4">
                            <label className='required' htmlFor="class_c_scheduling_type">Tipo de agendamento de classe C</label>
                            <Select
                                disabled= {detalhes.group_type.value !== "CLASS_C"}
                                options={optionsSelect.class_c_scheduling_type}
                                value={detalhes.class_c_scheduling_type}
                                onChange={(e) => this.handleChange("class_c_scheduling_type", e)}
                            />
                            <span id='validacao-class_c_scheduling_type'></span>
                        </div>
                    </div>
                </div>

                <div className="hdv-btn-group">
                    <ButtonsForm
                        route="/multicast/group"
                        edit={edit ? true : false}
                        cooldown={this.state.cooldown}
                        buttons={[
                            {
                                method: "post",
                                button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                            },

                            {
                                method: "post",
                                button: <button style={{ display: edit ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                            },

                            {
                                method: "patch",
                                button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                            },
                        ]}
                    />
                    <Link to={`/lns/application/${this.applicationId}/editar/2`}>
                        <button className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                    </Link>
                </div>
           </div>
        )
    }
}

export default FormGroupMulticast